export default "__VITE_ASSET__C62gwy_y__"